module.exports = "/_next/static/images/1d4dad3f2eae14b936c6400d963149e0-woman-holding-device-smiling@1x.jpg.webp";